import axios from "axios";

const modules = {

    async bulk(params = {}, active_tenant){
        return (await axios.get(`/api/${active_tenant}/modules`)).data;
    },

}

export default modules;
